
import Vue from 'vue';
import SkeletonLoader from '@root/common/components/base/loader/SkeletonLoader.vue';

export default Vue.extend({
  components: {
    SkeletonLoader,
  },
});
